export const fontsLobster = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Lobster-Regular.ttf",
      },
    ],
    weight: "400",
  },
];
